<template>
  <a-comment v-if="message.type === MessageType.Regular">
    <template #author>{{ message.author }}</template>
    <template #avatar> </template>
    <template #content>
      <a-flex
        vertical
        align="stretch"
        justify="flex-start"
        gap="small"
        :class="{ isMy: message.self }"
      >
        <a-typography-text v-if="message.text" class="comment">
          {{ message.text }}
        </a-typography-text>
        <template v-if="message.imagePath">
          <BaskitImage
            v-if="!message.imagePath.endsWith('pdf')"
            :url="message.imagePath"
            :width="'500px'"
          />
          <FilePdfOutlined
            style="
              font-size: 100px;
              color: var(--primary-red-color);
              cursor: pointer;
            "
            v-else
            @click="downloadAttachment(message.imagePath)"
          />
        </template>
      </a-flex>
    </template>
    <template #datetime>
      <a-tooltip
        :title="dayjs(message.createdDate).format('YYYY-MM-DD HH:mm:ss')"
      >
        <span>{{ dayjs(message.createdDate).fromNow() }}</span>
      </a-tooltip>
    </template>
  </a-comment>

  <a-typography-text strong type="danger" v-else>
    {{ dayjs(message.createdDate).format("YYYY-MM-DD HH:mm:ss") }}:
    {{ message.text }}
  </a-typography-text>
</template>

<script setup lang="ts">
import { h } from "vue";
import { UserOutlined, FilePdfOutlined } from "@ant-design/icons-vue";
import dayjs from "dayjs";
import { MessageType, type SupportUserMessage } from "@/api/api.dto";
import BaskitImage from "@/components/UI/BaskitImage.vue";
import { mediaUrl } from "../../../../env.d.ts";

defineProps<{
  message: SupportUserMessage;
}>();

const downloadAttachment = (url: string) => {
  const link = document.createElement("a");
  link.setAttribute("target", "_blank");
  link.href = url.includes("http") ? url : `${mediaUrl}/${url}`;
  link.download = url.split("/").pop() || "attachment";
  link.click();
};
</script>

<style scoped lang="scss">
.ant-avatar.ant-avatar-circle.ant-avatar-icon {
  background-color: var(--color-primary);
}

.ant-comment {
  :deep(.ant-comment-inner) {
    padding: 0;
  }

  :deep(.ant-comment-content-detail) {
    padding: 5px;
    border-radius: 5px;
    width: fit-content;

    .comment {
      white-space: pre-line;
    }

    &:has(.isMy) {
      background: var(--color-primary-bg-hover);
    }
  }
}
</style>
